export const content = {
    text: 'Page not found',
    textButon: 'Back to home',
    footer: {
        copy: '© 2022 Renshin, LLC',
        policy: { name: 'Privacy Policy', href: '/policy/' }
    }
}
